import { StandardEvents } from '@shopify/events';

const formatter = (currency) =>
  new Intl.NumberFormat('it-IT', { style: 'currency', currency });

class VyenoBuyboxTotal extends HTMLElement {
  connectedCallback() {
    this.form = this.closest('product-form-component');
    this.onQuantity = (event) => this.update(event.detail?.quantity);
    this.onChange = () => this.update();
    this.form?.addEventListener('quantity-selector:update', this.onQuantity);
    this.form?.addEventListener('change', this.onChange);
    this.update();
  }

  disconnectedCallback() {
    this.form?.removeEventListener('quantity-selector:update', this.onQuantity);
    this.form?.removeEventListener('change', this.onChange);
  }

  update(quantity) {
    const input = this.form?.querySelector('input[name="quantity"]');
    const selectedQuantity = Number(quantity || input?.value || 1);
    const coupleQuantity = Number(this.dataset.coupleQuantity || 2);
    const amount = selectedQuantity === coupleQuantity
      ? Number(this.dataset.couplePrice || 0)
      : Number(this.dataset.unitPrice || 0) * selectedQuantity;
    const output = this.querySelector('strong');
    if (output) output.textContent = formatter(this.dataset.currency || 'EUR').format(amount / 100);
  }
}

if (!customElements.get('vyeno-buybox-total')) {
  customElements.define('vyeno-buybox-total', VyenoBuyboxTotal);
}

function selectedColor() {
  return document.querySelector('variant-picker input:checked')?.value?.trim().toLowerCase() || '';
}

function syncVariantForm() {
  const selected = document.querySelector('variant-picker input:checked');
  const variantId = selected?.dataset.variantId;
  if (!variantId) return;
  document.querySelectorAll('.product-information product-form-component input[name="id"]').forEach((input) => {
    input.value = variantId;
    input.setAttribute('value', variantId);
  });
}

let selectedOfferQuantity = 1;
let selectedCoupleCombination = 'black-black';
let changingVariantFromCombination = false;

function priceForQuantity(quantity) {
  const total = document.querySelector('vyeno-buybox-total');
  const unitPrice = Number(total?.dataset.unitPrice || 0);
  const couplePrice = Number(total?.dataset.couplePrice || 0);
  const coupleQuantity = Number(total?.dataset.coupleQuantity || 2);
  return quantity === coupleQuantity ? couplePrice : unitPrice * quantity;
}

function syncPurchaseOption(quantity) {
  document.querySelectorAll('.product-information input[name="_vyeno_offer"]').forEach((input) => {
    input.checked = (input.value === 'couple' && quantity === 2) || (input.value === 'one' && quantity === 1);
  });
  syncCoupleControls(quantity);
}

function coupleFieldset() {
  return document.querySelector('.product-information [data-vyeno-couple-colors]');
}

function coupleLabel() {
  return selectedCoupleCombination.split('-').map((color) => color === 'black' ? 'Black' : 'Beige').join(' + ');
}

function syncCoupleControls(quantity) {
  const fieldset = coupleFieldset();
  const isCouple = quantity === 2;
  if (fieldset) {
    fieldset.hidden = !isCouple;
    const selected = fieldset.querySelector(`input[value="${selectedCoupleCombination}"]`);
    if (selected) selected.checked = true;
  }
  const quantityWrapper = document.querySelector('.product-information .quantity-selector-wrapper');
  if (quantityWrapper) quantityWrapper.hidden = isCouple;
  const stickyTitle = document.querySelector('.sticky-add-to-cart__title');
  if (stickyTitle) stickyTitle.textContent = isCouple ? 'VYENO Couple' : 'VYENO One';
  const stickyVariant = document.querySelector('.sticky-add-to-cart__variant');
  if (stickyVariant) {
    const variantLabel = document.querySelector('variant-picker input:checked')?.value?.trim() || '';
    stickyVariant.textContent = isCouple
      ? coupleLabel()
      : variantLabel.toLowerCase() === 'silver' ? 'Beige' : variantLabel;
  }
}

function coupleItems() {
  const fieldset = coupleFieldset();
  const black = fieldset?.dataset.blackVariantId;
  const beige = fieldset?.dataset.beigeVariantId;
  if (!black || !beige) return [];
  if (selectedCoupleCombination === 'black-beige') {
    return [{ variantId: black, quantity: 1 }, { variantId: beige, quantity: 1 }];
  }
  if (selectedCoupleCombination === 'beige-beige') return [{ variantId: beige, quantity: 2 }];
  return [{ variantId: black, quantity: 2 }];
}

function selectPrimaryCoupleColor() {
  const primaryColor = selectedCoupleCombination === 'beige-beige' ? 'beige' : 'black';
  const input = [...document.querySelectorAll('variant-picker input[type="radio"]')]
    .find((option) => option.value.trim().toLowerCase() === primaryColor);
  if (input && !input.checked) {
    changingVariantFromCombination = true;
    input.click();
  }
}

function syncStickyTotal(quantity) {
  const price = document.querySelector('.sticky-add-to-cart__price');
  const amount = priceForQuantity(quantity);
  if (price && amount) price.textContent = formatter('EUR').format(amount / 100);
}

function setPurchaseQuantity(quantity) {
  const selector = document.querySelector('.product-information quantity-selector-component');
  const input = selector?.querySelector('input[name="quantity"]');
  if (!selector || !input) return;

  selectedOfferQuantity = quantity;
  if (typeof selector.setValue === 'function') selector.setValue(String(quantity));
  else input.value = String(quantity);
  selector.onQuantityChange?.();
  selector.updateButtonStates?.();
  syncPurchaseOption(quantity);
  syncStickyTotal(quantity);
}

function mediaFileName(url) {
  return String(url || '').split('?')[0].split('/').pop();
}

async function syncVariantMedia(variant) {
  const featuredSource = variant?.featured_media?.preview_image?.src || variant?.featured_media?.src;
  await customElements.whenDefined('media-gallery');
  requestAnimationFrame(() => {
    const gallery = document.querySelector('.product-information media-gallery');
    const slides = [...(gallery?.querySelectorAll('slideshow-slide') || [])];
    const featuredFile = mediaFileName(featuredSource);
    const matchedIndex = featuredFile
      ? slides.findIndex((slide) => mediaFileName(slide.querySelector('img')?.currentSrc || slide.querySelector('img')?.src) === featuredFile)
      : -1;
    const index = matchedIndex >= 0 ? matchedIndex : 0;
    if (gallery?.slideshow?.select && gallery.media?.length > index) {
      gallery.slideshow.select(index, undefined, { animate: false });
      return;
    }
    const controls = [...(gallery?.querySelectorAll('slideshow-controls button') || [])];
    const target = controls.filter((button) => button.getAttribute('aria-label')?.startsWith(`Slide ${index + 1} `));
    (target.find((button) => button.offsetParent !== null) || target[0])?.click();
  });
}

document.addEventListener(StandardEvents.productSelect, (event) => {
  if (!event.target?.closest?.('.product-information')) return;
  event.promise?.then(({ detail }) => {
    syncVariantForm();
    syncVariantMedia(detail?.resource);
    setPurchaseQuantity(selectedOfferQuantity);
  }).catch(() => {});
});

document.addEventListener('change', (event) => {
  if (event.target?.matches?.('.product-information input[name="_vyeno_offer"]')) {
    if (event.target.value === 'couple') {
      selectedCoupleCombination = selectedColor() === 'beige' ? 'beige-beige' : 'black-black';
      setPurchaseQuantity(2);
    } else {
      setPurchaseQuantity(1);
    }
    return;
  }
  if (event.target?.matches?.('.product-information input[name="_vyeno_couple_colors"]')) {
    selectedCoupleCombination = event.target.value;
    syncCoupleControls(2);
    selectPrimaryCoupleColor();
    return;
  }
  if (!event.target?.closest?.('variant-picker')) return;
  if (selectedOfferQuantity === 2 && !changingVariantFromCombination) {
    selectedCoupleCombination = selectedColor() === 'beige' ? 'beige-beige' : 'black-black';
  }
  changingVariantFromCombination = false;
  syncVariantForm();
  window.setTimeout(() => {
    syncVariantForm();
    syncVariantMedia();
  }, 700);
});

document.addEventListener('quantity-selector:update', (event) => {
  if (!event.target?.closest?.('.product-information') || event.detail?.cartLine) return;
  selectedOfferQuantity = Number(event.detail?.quantity || 1);
  syncPurchaseOption(selectedOfferQuantity);
  syncStickyTotal(selectedOfferQuantity);
});

document.addEventListener('click', (event) => {
  if (event.target?.closest?.('[data-vyeno-couple-cta]')) {
    setPurchaseQuantity(2);
    document.querySelector('.product-information .buy-buttons-block')?.scrollIntoView({ behavior: 'smooth', block: 'center' });
    return;
  }
  const addButton = event.target?.closest?.('.product-information button[name="add"]');
  if (!addButton) return;
  syncVariantForm();
  if (selectedOfferQuantity === 2) {
    const form = addButton.closest('product-form-component');
    const items = coupleItems();
    if (form?.addItems && items.length) {
      event.preventDefault();
      event.stopImmediatePropagation();
      form.addItems(items);
    }
  }
}, true);

document.addEventListener('submit', (event) => {
  if (event.target?.closest?.('.product-information')) syncVariantForm();
}, true);

function syncInitialVariant() {
  window.setTimeout(() => {
    const input = document.querySelector('.product-information input[name="quantity"]');
    selectedOfferQuantity = Number(input?.value || 1);
    syncVariantForm();
    syncVariantMedia();
    syncPurchaseOption(selectedOfferQuantity);
    syncStickyTotal(selectedOfferQuantity);
  }, 300);
}

if (document.readyState === 'complete') {
  syncInitialVariant();
} else {
  window.addEventListener('load', syncInitialVariant, { once: true });
}
